import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'langFlag',
  standalone: false
})
export class LangFlagPipe implements PipeTransform {
  transform(lang: string): string {
    switch (lang) {
      case 'en': {
        return 'gb';
      }
      default: {
        return lang;
      }
    }
  }
}
